/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Draftemail_Access_Incc3Inputs */

const en_coinvestments_draftemail_access_incc3 = /** @type {(inputs: Coinvestments_Draftemail_Access_Incc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(in CC)`)
};

/**
* | output |
* | --- |
* | "(in CC)" |
*
* @param {Coinvestments_Draftemail_Access_Incc3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_draftemail_access_incc3 = /** @type {((inputs?: Coinvestments_Draftemail_Access_Incc3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Draftemail_Access_Incc3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_draftemail_access_incc3(inputs)
});
export { coinvestments_draftemail_access_incc3 as "coInvestments_draftEmail_access_inCc" }